import { WebOp, WebOpChecked } from './WebOp';

export const BlankWebOp: WebOp = {
    id: '',
    webTitle: '',
    webTitleEN: '',
    webTitleFR: '',
    estTime: '',
    spgOp: '',
    itemCostLow: '',
    itemCostHigh: '',
    opPriority: '',
    cause: '',
    urls: [{ trackUrls: '', mediaUrls: '', mediaType: '' }],
    why: '',
    what: '',
    reason: '',
    department: '',
    opWaiter: '',
    opLoaner: '',
    opRental: '',
    opConcierge: '',
    opCadillac: '',
    opPPUDWL: '',
    complaintDef: '',
};

const item1: WebOp = {
    id: '1',
    what: 'This is item 1',
    webTitle: 'ITEM 1',
    webTitleEN: 'ITEM 1',
    webTitleFR: 'ITEM 1',
    itemCostHigh: '$4.00',
    itemCostLow: '$1.00',
    why: 'This is for reason 1',
    estTime: '3',
    opPriority: '2',
    spgOp: '',
    cause: '',
    // urls: { trackUrls: [''], mediaUrls: [''], mediaType: [''] },
    urls: [{ trackUrls: '', mediaUrls: '', mediaType: '' }],
    reason: '',
    department: '',
    opWaiter: '',
    opLoaner: '',
    opRental: '',
    opConcierge: '',
    opCadillac: '',
    opPPUDWL: '',
    complaintDef: '',
};

const item2: WebOp = {
    id: '2',
    what: 'This is item 2',
    webTitle: 'ITEM 2',
    webTitleEN: 'ITEM 2',
    webTitleFR: 'ITEM 2',
    itemCostHigh: '$4.00',
    itemCostLow: '$4.00',
    why: 'This is for reason 2',
    estTime: '3',
    opPriority: '2',
    spgOp: 'Helo',
    cause: '',
    // urls: { trackUrls: [''], mediaUrls: [''], mediaType: [''] },
    urls: [{ trackUrls: '', mediaUrls: '', mediaType: '' }],
    reason: '',
    department: '',
    opWaiter: '',
    opLoaner: '',
    opRental: '',
    opConcierge: '',
    opCadillac: '',
    opPPUDWL: '',
    complaintDef: '',
};

const item3: WebOp = {
    id: '3',
    what: 'This is item 3',
    webTitle: 'ITEM 3',
    webTitleEN: 'ITEM 3',
    webTitleFR: 'ITEM 3',
    itemCostHigh: '$20.00',
    itemCostLow: '$3.00',
    why: 'This is for reason 3',
    estTime: '3',
    opPriority: '2',
    spgOp: '12312r32r3a',
    cause: '',
    // urls: { trackUrls: [''], mediaUrls: [''], mediaType: [''] },
    urls: [{ trackUrls: '', mediaUrls: '', mediaType: '' }],
    reason: '',
    department: '',
    opWaiter: '',
    opLoaner: '',
    opRental: '',
    opConcierge: '',
    opCadillac: '',
    opPPUDWL: '',
    complaintDef: '',
};

export const TestWebOp = [item1, item2, item3];

export const TestWebOpChecked: WebOpChecked[] = [
    { id: '2' },
];